<svelte:options runes={false} />

<script>
  import { invoiceStatusTone, statusLabel } from '../status-labels.mjs';
  import StatusPill from './StatusPill.svelte';

  export let invoices;
  export let activeInvoiceId;
  export let onSelect;
</script>

<div class="invoice-list operator-invoice-list">
  {#each invoices as candidate (candidate._id)}
    <!-- Selection was `class:primary`, which filled the whole row with the action
         colour and needed a rule elsewhere to force the secondary line back to
         white. It now reads the way the payer surface already marks a chosen row:
         an accent rule down the edge. `aria-current` says the same thing to a
         screen reader, which previously had no way to tell which row was open. -->
    <button
      aria-current={candidate._id === activeInvoiceId ? 'true' : undefined}
      class:selected={candidate._id === activeInvoiceId}
      type="button"
      on:click={() => onSelect(candidate._id)}
    >
      <span class="invoice-row-recipient">{candidate.recipientLabel}</span>
      <span class="invoice-row-secondary quiet">
        <StatusPill label={statusLabel(candidate.status)} tone={invoiceStatusTone(candidate.status)} />
        {#if candidate.dueAt}<span>due {candidate.dueAt.toLocaleDateString?.() || ''}</span>{/if}
      </span>
    </button>
  {/each}
  {#if invoices.length === 0}
    <p class="quiet">No invoices on this page.</p>
  {/if}
</div>
